/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetApiBookingSequentialSlots200, GetApiBookingSequentialSlotsQueryParams, GetApiBookingSequentialSlotsQueryResponse } from "../entities/GetApiBookingSequentialSlots";
import { modelsSequentialAvailableSlotsResponseSchema } from "./models/sequentialAvailableSlotsResponseSchema";
import { z } from "zod/v4";

export const getApiBookingSequentialSlotsQueryParamsSchema = z.object({
    "parent_service_id": z.coerce.number().int().describe("ID услуги родителя"),
"child_service_id": z.coerce.number().int().describe("ID услуги ребенка"),
"barber_id": z.optional(z.coerce.number().int().describe("ID мастера")),
"date": z.optional(z.string().describe("Дата (YYYY-MM-DD)")),
"branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<GetApiBookingSequentialSlotsQueryParams>

/**
 * @description OK
 */
export const getApiBookingSequentialSlots200Schema = z.lazy(() => modelsSequentialAvailableSlotsResponseSchema) as unknown as z.ZodType<GetApiBookingSequentialSlots200>

export const getApiBookingSequentialSlotsQueryResponseSchema = z.lazy(() => getApiBookingSequentialSlots200Schema) as unknown as z.ZodType<GetApiBookingSequentialSlotsQueryResponse>